import { AfterViewChecked, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from "../button/button.component";
import { FocusTrapDirective } from '../../directives/focus-trap.directive';

@Component({
  selector: 'ppl-alertbox',
  standalone: true,
  imports: [CommonModule, ButtonComponent, FocusTrapDirective],
  templateUrl: './alertbox.component.html',
  styleUrl: './alertbox.component.css'
})
export class AlertboxComponent implements AfterViewChecked {
  @Input() isAlertVisible = false;
  @Output() isAlertVisibleChange = new EventEmitter<boolean>();
  @Input() title ='';
  @Input() message = '';
  @Input() success = false;
  @Output() onClose = new EventEmitter<void>();
  @ViewChild('dialogContainer') dialogContainer!: ElementRef;
  @ViewChild('gotItButton') gotItButton!: ElementRef;
  @ViewChild('alertMessageContainer') alertMessageContainer!: ElementRef;
  private hasFocused = false;

  ngAfterViewChecked() {
    if (this.isAlertVisible && this.dialogContainer && !this.hasFocused) {
      const hasTitle = this.title?.trim().length > 0;
      const hasMessage = this.alertMessageContainer?.nativeElement?.textContent?.trim().length > 0;
      if (hasTitle && hasMessage) {
      setTimeout(() => {
        this.gotItButton?.nativeElement?.focus();
        this.hasFocused = true;
      }, 0);
    }
    } else if (!this.isAlertVisible) {
      this.hasFocused = false;
    }
  }

  closeAlert(): void {
    this.isAlertVisible = false;
    this.isAlertVisibleChange.emit(this.isAlertVisible); // Emit changes when closing the alert
    this.onClose.emit();
  }
}